import { render, staticRenderFns } from "./ProductionZPV3.vue?vue&type=template&id=2c8d6cb3&scoped=true&"
import script from "./ProductionZPV3.vue?vue&type=script&lang=js&"
export * from "./ProductionZPV3.vue?vue&type=script&lang=js&"
import style0 from "./ProductionZPV3.vue?vue&type=style&index=0&id=2c8d6cb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d6cb3",
  null
  
)

export default component.exports